import * as jQuery from 'jquery';
var $ = jQuery;
export function heroWidgetScripts() {
    $(document).ready(function () {
        'use strict';
        // Function to find background video in parent containers
        function findBackgroundVideo() {
            var currentElement = $('.hero-widget').closest('.elementor-element.e-con');
            var videoElement = null;
            // Look for video elements in the current container and parent containers
            while (currentElement.length > 0) {
                // Check for video elements
                videoElement = currentElement.find('video').first();
                if (videoElement.length > 0) {
                    break;
                }
                // Check for background video in CSS
                var backgroundVideo = currentElement.css('background-image');
                if (backgroundVideo && backgroundVideo.includes('video')) {
                    // Look for video element that might be positioned absolutely
                    videoElement = currentElement.find('video').first();
                    if (videoElement.length === 0) {
                        // Check parent containers for video
                        videoElement = currentElement.parents().find('video').first();
                    }
                    if (videoElement.length > 0) {
                        break;
                    }
                }
                // Move up to parent container
                currentElement = currentElement.parents('.elementor-element.e-con').first();
            }
            return videoElement;
        }
        // Function to initialize video controls
        function initVideoControls() {
            var videoElement = findBackgroundVideo();
            var pauseBtn = $('#hero-pause-btn');
            var pauseIcon = pauseBtn.find('.pause-icon');
            var playIcon = pauseBtn.find('.play-icon');
            if (videoElement && videoElement.length > 0) {
                // Show the pause button
                pauseBtn.show();
                // Set initial state
                if (videoElement[0].paused) {
                    pauseIcon.hide();
                    playIcon.show();
                }
                else {
                    pauseIcon.show();
                    playIcon.hide();
                }
                // Handle pause button click
                pauseBtn.off('click').on('click', function () {
                    var video = videoElement[0];
                    if (video.paused) {
                        // Play video
                        video.play().catch(function (error) {
                            console.error('Error playing video:', error);
                        });
                        pauseIcon.show();
                        playIcon.hide();
                    }
                    else {
                        // Pause video
                        video.pause();
                        pauseIcon.hide();
                        playIcon.show();
                    }
                });
                // Update button state when video state changes
                videoElement.off('play pause ended').on('play', function () {
                    pauseIcon.show();
                    playIcon.hide();
                });
                videoElement.on('pause', function () {
                    pauseIcon.hide();
                    playIcon.show();
                });
                // Handle video end
                videoElement.on('ended', function () {
                    pauseIcon.hide();
                    playIcon.show();
                });
                //console.log('Hero widget video controls initialized');
            }
            else {
                //console.log('No background video found for hero widget');
            }
        }
        // Initialize when DOM is ready
        initVideoControls();
        // Also check after a delay to catch any late-loading videos
        setTimeout(initVideoControls, 1000);
    });
}
